module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cancer/cnc_oc-401688bfafc8335a915db8c3cbf9c2b6.gif";